import type { PlanLegislation } from '../types/types'

export function lovdataUrl(documentId: string): string {
  return `https://lovdata.no/dokument/${documentId
    .split('/')
    .map(encodeURIComponent)
    .join('/')}`
}

function referenceTarget(partId: string, label: string): string | undefined {
  // Embedded regulations use nested chapter IDs; paragraphs target that chapter.
  const chapter = partId.match(
    /^(kapittel-\d+(?:-kapittel-\d+)*)(?:-ledd-\d+)?$/
  )
  if (chapter) return `KAPITTEL_${chapter[1].replaceAll('kapittel-', '')}`
  // Public Lovdata links target the containing section, not an individual paragraph.
  // Saved labels include ancestor headings; competing references are ambiguous.
  const sections = Array.from(
    label.matchAll(
      /(?<!§)§(?!§)\s*(\d+(?:-\d+)*(?:\s*[a-zæøå])?)(?=[.,\s]|$)/gi
    )
  )
  if (sections.length !== 1) return
  const section = sections[0]
  // Require a heading segment, never an inline citation such as "Tiltak etter § 2".
  if (!/(?:^|,\s*)$/.test(label.slice(0, section.index))) return
  return `§${section[1].replace(/\s/g, '').toLowerCase()}`
}

export function legislationReferences(
  documentId: string,
  selectedParts: PlanLegislation['selectedParts']
) {
  const documentUrl = lovdataUrl(documentId)
  // Keep exactly one row per saved selection, in the original order—even when
  // several selections navigate to the same section on Lovdata.
  return selectedParts.map(({ id, label }) => {
    const target = referenceTarget(id, label)
    const encoded = target ? encodeURIComponent(target) : undefined
    return {
      id,
      label,
      href: encoded ? `${documentUrl}/${encoded}#${encoded}` : undefined
    }
  })
}
